/**
 * Silences console.log and console.warn unless VITE_LOG=true.
 * console.error is always preserved.
 * Import this as early as possible in the app entry point.
 */
if (import.meta.env.VITE_LOG !== "true") {
  const noop = () => {};
  console.log = noop;
  console.warn = noop;
}
